/* eslint-disable */
import React from 'react';
import { TableRow, TableCell, Checkbox } from '@mui/material';
import TableCellItem from './TableCellItem';

/**
 * TableRowItem
 *
 * Renders a single data <TableRow> with all its cells.
 *
 * Props:
 *  row          {object}   — data row
 *  columns      {array}    — column definitions
 *  index        {number}   — row index
 *  selectable   {boolean}  — show leading checkbox
 *  selected     {boolean}  — is this row selected
 *  onSelect     {function} — (row) => void
 *  onClick      {function} — (row) => void  (row click handler)
 *  hasGrouping  {boolean}  — add indent cell
 *  sx           {object}   — extra sx for the row
 */
const TableRowItem = ({
  row,
  columns,
  index,
  selectable = false,
  selected = false,
  onSelect,
  onClick,
  hasGrouping = false,
  sx = {},
}) => (
  <TableRow
    hover
    onClick={onClick ? () => onClick(row) : undefined}
    sx={{
      cursor: onClick ? 'pointer' : 'default',
      backgroundColor: selected ? '#EBF5FB' : 'inherit',
      '&:hover': { backgroundColor: selected ? '#EBF5FB' : 'inherit' },
      transition: 'background-color 0.15s',
      ...sx,
    }}
  >
    {/* Grouping indent */}
    {hasGrouping && (
      <TableCell sx={{ width: 32, py: '14px', px: '8px', borderBottom: '1px solid #F0F2F5' }} />
    )}

    {/* Checkbox */}
    {selectable && (
      <TableCell
        sx={{ py: '14px', px: '16px', borderBottom: '1px solid #F0F2F5' }}
        onClick={(e) => e.stopPropagation()}
      >
        <Checkbox
          size="small"
          checked={selected}
          onChange={() => onSelect && onSelect(row)}
          sx={{ color: '#DEE5EE', '&.Mui-checked': { color: '#007BC6' } }}
        />
      </TableCell>
    )}

    {/* Data cells */}
    {columns.map((col) => (
      <TableCellItem key={col.id} column={col} row={row} index={index} />
    ))}
  </TableRow>
);

export default TableRowItem;
